import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { ListComponentGeneric } from '../../../../ui/generics';
import { ICategory, IEvent, ISeminar } from '../../core/interfaces';
import { SeminarsErrorResolverService, SeminarsEventsService } from '../../core/services';
import { NotificationService } from '../../../../core/services';
import { finalize } from 'rxjs/operators';
import { FilterOperator } from '../../../../core/types';

@Component({
    selector: 'app-events-table',
    templateUrl: './events-table.component.html',
    styleUrls: ['./events-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EventsTableComponent extends ListComponentGeneric<IEvent> implements OnInit {

  @Input() seminar: ISeminar;
  @Input() category: ICategory;
  @Input() showAddButton = true;
  @Input() isDasboard = false;

  public filter1 = false;
  public filter2 = true;

  protected readonly exportedTableVisibleName = 'Veranstaltungen';
  protected searchColumns = ['name', 'orderNumber', 'id', 'comment', 'seats', 'leader'];
  protected readonly defaultSorting: { sortField: string; sortOrder: string; } = {
    sortField: 'beginning',
    sortOrder: 'ascend'
  };

  public constructor(
    protected _service: SeminarsEventsService,
    protected _cdr: ChangeDetectorRef,
    protected _notify: NotificationService,
    protected renderer: Renderer2,
    protected _errorResolver: SeminarsErrorResolverService,
  ) {
    super(_service, _cdr, _notify, renderer, _errorResolver);
  }

  public override ngOnInit(): void {
    if (this.seminar) {
      this.predefindedFilters = [
        {
          key: 'seminarId',
          value: [this.seminar.id.toString()]
        }
      ];
    } else if (this.category) {
      this.predefindedFilters = [
        {
          key: 'seminar.categoryId',
          value: [this.category.id.toString()]
        }
      ];
    }

    if (this.isDasboard) {
      this.pageSize = 5;
    }

    super.ngOnInit();
  }

  callService( pageIndex: number,
               pageSize: number,
               sortField: string | null,
               sortOrder: string | null,
               filters: Array<{ key: string; value: string[]; operator?: FilterOperator; }>,
               search: Array<{ key: string; value: string[]; operator?: FilterOperator; }>,
               additionalFilters: Array<{ key: string; value: string[]; operator?: FilterOperator; }>,
  ) {
    if (this.filter1) {
      filters.push({key: 'isArchived', value: ['true']});
    } else if (this.filter2) {
      filters.push({key: 'isArchived', value: ['false']});
    }

    if (sortField === 'attendees.count()') {
      sortOrder = sortOrder === 'ascend' ? 'descend' : 'ascend';
    }

    this.loading = true;
    this._listService.getQueryableAll(pageIndex, pageSize, sortField, sortOrder, filters, search, additionalFilters).subscribe(res => {
      this.loading = false;
      this.data = res;
      this.onListDataAvailable();
      this._cdr.detectChanges();
    }, this.parseError);
  }

  public archiveEvent(id: number): void {
    this.loading = true;
    this._service.archiveEvent(id).pipe(
      finalize(() => this.loading = false)
    ).subscribe(() => this.onRefreshList(false), this.parseError);
  }
}
